import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const response = await api.get('/api/admin/check-auth');
      if (response.data.authenticated) {
        setUser(response.data.user || { username: response.data.username || 'admin', role: response.data.role || 'administrator' });
        setIsAuthenticated(true);
      } else {
        if (response.data.kickedByOtherAdmin) {
          alert('Вы были разлогинены другим администратором');
        }
        setIsAuthenticated(false);
        setUser(null);
      }
    } catch (error) {
      console.error('Ошибка проверки авторизации:', error);
      setIsAuthenticated(false);
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const login = async (username, password, force = false) => {
    try {
      const response = await api.post('/api/admin/login', { username, password, force });
      if (response.data.success) {
        setUser({ username: response.data.username || username, role: response.data.role || 'administrator' });
        setIsAuthenticated(true);
        return { success: true };
      }
      return { 
        success: false, 
        code: response.data.code,
        error: response.data.error || response.data.message || 'Неверные данные' 
      };
    } catch (error) {
      console.error('Ошибка входа:', error);
      return { 
        success: false, 
        code: error.response?.data?.code,
        error: error.response?.data?.error || error.response?.data?.message || 'Ошибка сервера' 
      };
    }
  };

  const logout = async () => {
    try {
      await api.post('/api/admin/logout');
    } catch (error) {
      console.error('Ошибка выхода:', error);
    } finally {
      setUser(null);
      setIsAuthenticated(false);
    }
  };

  return (
    <AuthContext.Provider value={{ user, isAuthenticated, loading, login, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth должен использоваться внутри AuthProvider');
  }
  return context;
}
